import { render } from "./Messages.vue?vue&type=template&id=61ea825e&scoped=true"
const script = {}

import "./Messages.vue?vue&type=style&index=0&id=61ea825e&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ea825e"]])

export default __exports__